'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc service
 * @name DataService
 *
 * @description
 * http request for async data from backend;
 */

var DataService = function () {
    function DataService($resource) {
        'ngInject';

        (0, _classCallCheck3.default)(this, DataService);
        this.$resource = $resource;
    }

    (0, _createClass3.default)(DataService, [{
        key: 'API',
        value: function API() {
            //return this.$resource('http://0.0.0.0:3000/api/:type/:id',
            return this.$resource('/api/:type/:id', { type: '@type', id: '@id' }, {
                update: { method: 'PUT', cache: false, isArray: false }
            });
        }
    }]);
    return DataService;
}();

exports.default = DataService;


// WEBPACK FOOTER //
// ./client/app/common/services/data.service.js